export default function initBeforeunload() {
  const { environment, beforeUnloadMessage } = window.NaturkartanConfig || {}

  if (environment == `dev`) return // don't enable beforeunload in dev, as it can be annoying when doing frequent reloads

  function handleWinBeforeunload(e) {
    e.preventDefault()
    return beforeUnloadMessage || ``
  }

  function handleDocClick(e) {
    const link = e.target.closest(`a[data-phx-link]`)
    if (!link) return

    if (!confirm(beforeUnloadMessage)) {
      e.preventDefault()
      e.stopImmediatePropagation()
    } else stop()
  }

  function start() {
    window.addEventListener(`beforeunload`, handleWinBeforeunload)
    document.addEventListener(`click`, handleDocClick, true)
  }

  function stop() {
    window.removeEventListener(`beforeunload`, handleWinBeforeunload)
    document.removeEventListener(`click`, handleDocClick, true)
  }

  window.addEventListener(`phx:start-beforeunload`, start)
  window.addEventListener(`phx:stop-beforeunload`, stop)
}
